<template>
  <el-row :gutter="10" class="home text-white">
    <el-col :span="6">
      <div class="bg-white pad-a-sm" style="height: 65px;">
        <div class="pull-right">
          <!-- <i class="fas fa-leaf text-primary pad-r-md"
            style="font-size: 40px; line-height: 60px;"></i> -->
          <img id="icon1" class="pad-r-xs" src="/img/icon1.png">
        </div>
        <div class="text-item text-left pad-b-xs mar-l-xxl">
          {{ hdata.IpcCount ? hdata.IpcCount : '-' }}</div>
        <div class="text-title text-left">环境质量接入平台数</div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="bg-white pad-a-sm" style="height: 65px;">
        <div class="pull-right">
          <img id="icon2" class="pad-r-xs" src="/img/icon2.png">
        </div>
        <div class="text-item text-left pad-b-xs mar-l-xxl">
          {{ hdata.DciCount ? hdata.DciCount : '-' }}</div>
        <div class="text-title text-left">污染源接入平台数</div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="bg-white pad-a-sm" style="height: 65px;">
        <div class="pull-right">
          <img id="icon3" class="pad-r-xs" src="/img/icon3.png">
        </div>
        <div class="text-item text-left pad-b-xs mar-l-xl">
          {{ hdata.DciSoftwareCount ? hdata.DciSoftwareCount : '-' }}</div>
        <div class="text-title text-left">数采仪驱动数量</div>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="bg-white pad-a-sm" style="height: 65px;">
        <div class="pull-right">
          <img id="icon4" class="pad-r-xs" src="/img/icon4.png">
        </div>
        <div class="text-item text-left pad-b-xs mar-l-xl">
          {{ hdata.IpcSoftwareCount ? hdata.IpcSoftwareCount : '-' }}</div>
        <div class="text-title text-left">工控产品数量</div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    hdata: {
      type: Object || Array,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~variables";
.home {
  .el-col {
    margin-bottom: 10px;
  }
}
.bg-white {
  background: mix($--color-black, $--color-white, 70%);
}
.text-title {
  font-size: 16px;
  font-weight: bold;
  color: #000 !important;
}
.text-item {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-family: 'Rubik', sans-serif;
  color: #38a0f4;
}
</style>
